module.exports = __webpack_public_path__ + "media/images/onboarding-1-900933c51891737f6ef9e3b2ab0010d0.webp";